
export default {
  roles: state => state.rolesList,
  isRoleMatching: state => (roles) => {
    if (!state.user || !state.user.roles) {
      return false;
    }
    if (!roles) {
      return true;
    }
    return state.user.roles.some(item => roles.includes(item));
  },
};
